export class StorageKeys{

  static TEST_STORAGE_KEY = 'TEST_STORAGE_KEY';

}
